module.exports = function csp(options = {}) {
    return (req, res, next) => {
        const policies = [];
        for (const [key, value] of Object.entries(options)) {
            const directive = Array.isArray(value) ? value.join(' ') : value;
            policies.push(`${key} ${directive}`);
        }
        if (policies.length > 0) {
            res.setHeader('Content-Security-Policy', policies.join('; '));
        }
        next();
    };
};
